import axiosInstance from "./axiosInstance";

/** Sparse legacy pages may contain fewer rows than their declared page size. */
export async function readAllPages(url, config = {}, request = axiosInstance) {
  const query = new URL(url);
  const size = Math.max(1, Number(query.searchParams.get("Limit")) || 50);
  const rows = new Map();
  let current = 1, declaredLast = 1, response, firstPayload;
  do {
    config.cancelToken?.throwIfRequested();
    query.searchParams.set("Page", current);
    response = await request(query.toString(), { timeout: 15000, ...config });
    const payload = response.data;
    firstPayload ||= payload;
    if (!Array.isArray(payload?.data)) throw new Error("پاسخ فهرست معتبر نیست.");
    const totalPages = Number(payload.meta?.total_pages);
    if (Number.isSafeInteger(totalPages) && totalPages > 0) declaredLast = Math.max(declaredLast, totalPages);
    if (declaredLast > 10000) throw new Error("فهرست برای دریافت کامل بیش از حد بزرگ است.");
    const before = rows.size;
    for (const row of payload.data) {
      const id = row.id ?? row.Id;
      if (id == null) throw new Error("رکورد بدون شناسه در فهرست دریافت شد.");
      rows.set(String(id), row);
    }
    if (current > 1 && payload.data.length && rows.size === before) throw new Error("صفحه تکراری در پاسخ فهرست دریافت شد.");
    // Probe beyond the declared end; never stop on an empty or short middle page.
    if (current > declaredLast && !payload.data.length) break;
    if (!Number.isSafeInteger(totalPages) && payload.data.length === size) declaredLast = current + 1;
    if (current >= declaredLast && payload.data.length) declaredLast = current;
    current++;
  } while (current <= declaredLast + 1);
  return { ...firstPayload, data: [...rows.values()] };
}
